module.exports = "<div class=transition-container__contents ng-click=$ctrl.AppServices.TransitionManager.open()> <div class=\"transition-container__panel transition-container__panel--left\"> </div> <div class=\"transition-container__panel transition-container__panel--right\"> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/transition-container/transition-container.html
 ** module id = 92
 ** module chunks = 0
 **/